__webpack_require__.p = "https://qa-google-workspace-mfe.digital.vpsvc.com/";